import React, { useEffect, useState } from 'react';
import resultStyle from './ResultSearchingPage.module.css'
import AuthorProfilePage from '../authorprofilepage/AuthorProfilePage'
import { useMediaQuery } from 'react-responsive';
import benefitone from '../../../assets/images/lady-img.png';
import { Link } from 'react-router-dom';
import { IoSearch } from "react-icons/io5";
import { FaUser } from "react-icons/fa6";
import { GoGlobe } from "react-icons/go";
import { IoShareOutline } from "react-icons/io5";
import { FaHeart } from "react-icons/fa";
import axios from "axios";
import { useLocation } from 'react-router-dom';
require('typeface-poppins')

export default function ResultSearchingPage() {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const location = useLocation();
  const passedUsers = location.state?.users || []; // get users from navigation or fallback

  const [filteredUsers, setFilteredUsers] = useState(passedUsers);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [category, setCategory] = useState('');
  const [genre, setGenre] = useState([]);
  const [region, setRegion] = useState('');
  const [category1, setCategory1] = useState([]);
  const [genre1, setGenre1] = useState([]);
  const [region1, setRegion1] = useState([]);
  const [items, setItems] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedGenres, setSelectedGenres] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  // const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {

    if (passedUsers.length > 0) {
      setLoading(false); // stop loading spinner if data is already passed
      return;
    }

    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data_all.php`);

        setUsers(response.data.users);
        setGenre1([{ 0: "Any", genre_name: "Any" }, ...response.data.genres]);
        setRegion1(response.data.regions);
        setCategory1(response.data.categories);
        setLoading(false);
        setFilteredUsers(response.data.users); // Initialize filtered users to all users
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Combine the three states into one array and update the items state
    setItems([category1, genre1, region1]);
  }, [category1, genre1, region1]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const handleGenreChange = (value) => {
    // Check if "Any" is being toggled
    const isAnySelected = value.includes("Any");
    const wasAnySelected = selectedGenres.includes("Any");

    if (isAnySelected && !wasAnySelected) {
      // If "Any" is being selected, select all genres
      const allGenres = genre1
        .filter(genre => genre.genre_name !== "Any")
        .map(genre => genre.genre_name);
      setSelectedGenres([...allGenres, "Any"]);
    } else if (!isAnySelected && wasAnySelected) {
      // If "Any" is being deselected, deselect all genres
      setSelectedGenres([]);
    } else {
      // Handle individual selections/deselections
      if (value.length === 0) {
        setSelectedGenres([]);
      } else {
        // If all items except one are deselected, keep the selection
        setSelectedGenres(value);
      }
    }
  };

  const handleCategoryChange = (value) => {
    setSelectedCategories(value);
  };

  const handleRegionChange = (value) => {
    setSelectedRegions(value);
  };

  const handleSearch = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/filterdata.php`, {
        genres: JSON.stringify(selectedGenres),
        categories: JSON.stringify(selectedCategories),
        regions: JSON.stringify(selectedRegions),
      });
      if (response.data.success) {
        setFilteredUsers(response.data.users);
        // console.log(response.data.query); 
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleSearch1 = async (query1) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/filterauthor.php`, {
        params: { query1 }
      });
      if (response.data.success) {
        setFilteredUsers(response.data.users);
      }
      else {
        //setFilteredUsers(false);
      }
    } catch (err) {
      console.error(err);
    }
  }

  const genreArr = genre1.map((item) => item.genre_name)
  const genredata = genreArr.map(
    item => ({ label: item, value: item })
  );

  const categoryArr = category1.map((item) => item.category_name)
  const categorydata = categoryArr.map(
    item => ({ label: item, value: item })
  );

  const regionArr = region1.map((item) => item.region_name)
  const regiondata = regionArr.map(
    item => ({ label: item, value: item })
  );

  return (
    <>
      {isMobile ? (
        <div className={resultStyle.mobilauthorpart}>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <h4 className={resultStyle.mobilauthorpartTitle}>Top Authors for Eventsd</h4>
              </div>
            </div>
            <div className='row g-3'>
              {filteredUsers.length > 0 ? (
                filteredUsers.map((user, index) => (
                  <div key={index} className='col-xl-12 col-lg-12'>
                    <div className={resultStyle.mobilauthorsBoxes}>
                      <div className="row">
                        <div className='col-3 px-2'>
                          <div className={resultStyle.mobilauthorImagebox}>
                            <img src={`${process.env.REACT_APP_API_BASE_URL}authormeetapi/images/author/${user.author_id}`} className={`${resultStyle.mobilauthorImage} img-fluid`} onError={(e) => { e.target.onerror = null; e.target.src = benefitone; }} />
                          </div>
                        </div>
                        <div className='col-4 px-1'>
                          <div className={resultStyle.mobilauthorInformation}>
                            <h6 className={resultStyle.mobilauthorinfoTitle}> {user.f_name} {user.l_name} </h6>
                            <div className={resultStyle.mobilauthorInfo}>
                              <span> Willing to Travel? </span>&nbsp; {user.willingtotravel}
                            </div>
                            <div className={`${resultStyle.mobilauthorInfo} pb-0`}>
                              <span> Region: </span>&nbsp; {user.region}
                            </div>
                          </div>
                        </div>
                        <div className='col-5 px-1'>
                          <div className={resultStyle.mobilauthorInformation}>
                            <div className={`${resultStyle.mobilauthorIcons} d-flex flex-wrap`}>
                              <Link to={`/AuthorProfilePage/${user.author_id}`} element={<AuthorProfilePage />}>
                                <FaUser className={`${resultStyle.mobilauthorAuthorary} me-3`} />
                              </Link>
                              {user.website && (
                                <Link to={user.website.startsWith('http') ? user.website : `https://${user.website}`} target="_blank" rel="noopener noreferrer">
                                  <GoGlobe className={`${resultStyle.mobilauthorAuthorary} me-3`} />
                                </Link>
                              )}
                              <Link> <IoShareOutline className={`${resultStyle.mobilauthorAuthorary} me-3`} /> </Link>
                              <Link> <FaHeart className={`${resultStyle.mobilauthorAuthorary} me-3`} /> </Link>
                            </div>
                            <div className={resultStyle.mobilauthorInfo}>
                              <span> Category: </span>&nbsp; {user.category}
                            </div>
                            <div className={`${resultStyle.mobilauthorInfo} pb-0`}>
                              <span> Genre: </span>&nbsp; {user.genre}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className='col-12'>
                          <p className={resultStyle.mobilauthorBiographytxt}> {user.biography} </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className={resultStyle.MobilauthornoAuthorFind}>No authors found based on the filters.</div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className={resultStyle.Desktopauthorpart}>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <h4 className={resultStyle.DesktopauthorpartTitle}>Top Authors for Events</h4>
              </div>
            </div>
            <div className='row g-3'>
              {filteredUsers.length > 0 ? (
                filteredUsers.map((user, index) => (
                  <div key={index} className='col-xl-6 col-lg-6'>
                    <div className={resultStyle.DesktopauthorsBoxes}>
                      <Link to={`/AuthorProfilePage/${user.author_id}`}>
                        <div className="row">
                          <div className='col-sm-3 px-2'>
                            <div className={resultStyle.DesktopauthorImagebox}>
                              <img src={`${process.env.REACT_APP_API_BASE_URL}authormeetapi/images/author/${user.author_id}`} className={`${resultStyle.DesktopauthorImage} img-fluid`} onError={(e) => { e.target.onerror = null; e.target.src = benefitone; }} />
                            </div>
                          </div>
                          <div className='col-sm-6 px-2'>
                            <div className={resultStyle.DesktopauthorDescription}>
                              <h4>{user.f_name} {user.l_name}</h4>
                              <p>{user.biography}</p>
                            </div>
                          </div>
                          <div className='col-sm-3 px-1'>
                            <div className={resultStyle.DesktopauthorInformation}>
                              <div className={`${resultStyle.DesktopauthorIcons} d-flex flex-wrap`}>
                                <Link to={`/AuthorProfilePage/${user.author_id}`} element={<AuthorProfilePage />}>
                                  <FaUser className={`${resultStyle.DesktopauthorAuthorary} me-3`} />
                                </Link>
                                {user.website && (
                                  <Link to={user.website.startsWith('http') ? user.website : `https://${user.website}`} target="_blank" rel="noopener noreferrer">
                                    <GoGlobe className={`${resultStyle.DesktopauthorAuthorary} me-3`} />
                                  </Link>
                                )}
                              </div>
                              <div className={resultStyle.DesktopauthorInfo}>
                                <span>Willing to Travel? </span>&nbsp; {user.willingtotravel}
                              </div>
                              <div className={resultStyle.DesktopauthorInfo}>
                                <span>Region: </span>&nbsp; {user.region}
                              </div>
                              <div className={resultStyle.DesktopauthorInfo}>
                                <span>Category: </span>&nbsp; {user.category}
                              </div>
                              <div className={resultStyle.DesktopauthorInfo}>
                                <span>Genre: </span>&nbsp; {user.genre}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>))
              ) : (
                <div className={resultStyle.DesktopauthornoAuthorFind}>No authors found based on the filters.</div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
